module.exports = __webpack_public_path__ + "img/search-icon.c6689c13.svg";